import { AwsRum } from 'aws-rum-web';

const awsRumIds = new Map([
    [
        'identityprovider.letsgetchecked.com',
        {
            identityPoolId: 'us-east-1:aeb6d3a0-8ee0-4c75-b8d3-4166f9379609',
            applicationId: '0e69d5af-166e-4dc5-94ee-9c7ac664412e'
        }
    ],
    [
        'identityprovider.letsgetchecked-stg2.com',
        {
            identityPoolId: 'us-east-1:abdd251c-cf81-4371-9a3e-0b67883ee1b3',
            applicationId: '688861f5-cd81-4e3f-aa9d-7602518720cb'
        }
    ],
    [
        'identityprovider.letsgetchecked-dev2.com',
        {
            identityPoolId: 'us-east-1:f112d09e-816f-48a2-98c0-b593d6f8fb0d',
            applicationId: 'f76b0820-a926-49e8-bbf9-b28639b19de5'
        }
    ],
    [
        'identityprovider.letsgetchecked-dev1.com',
        {
            identityPoolId: 'us-east-1:13379f97-ba83-4135-b5cc-528ad7d22e49',
            applicationId: '2b093eb6-dda9-4ae7-8d2b-9aa2c108c548'
        }
    ]
]);

function initializeAwsRum() {
    const applicationVersion = `{{applicationVersion}}`;
    const isLocal = applicationVersion.includes('applicationVersion');
    const awsRumEnvConfig = {
        applicationId: awsRumIds.get(location.host)?.applicationId || '',
        applicationVersion: isLocal ? 'local' : applicationVersion,
        applicationRegion: 'us-east-1',
        config: {
            sessionSampleRate: 1,
            identityPoolId: awsRumIds.get(location.host)?.identityPoolId || '',
            endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com',
            telemetries: ['performance', 'errors', 'http'],
            allowCookies: true,
            enableXRay: false,
            cookieAttributes: {
                unique: true
            }
        }
    };

    try {
        return new AwsRum(
            awsRumEnvConfig.applicationId,
            awsRumEnvConfig.applicationVersion,
            awsRumEnvConfig.applicationRegion,
            awsRumEnvConfig.config
        );
    } catch (error) {
        // Ignore errors thrown during CloudWatch RUM web client initialization
        return undefined;
    }
}

const cwr = initializeAwsRum();

export default cwr;